import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';

@Injectable()
export class Helpers {

	constructor( private fire: AngularFirestore ) {}

	shuffleUp( array ) {
		for (let i = array.length - 1; i > 0; i-- ) {
			let j = Math.floor(Math.random() * (i + 1));
			[array[i], array[j]] = [array[j], array[i]];
		}
		return array;
	}

	changeState(roomcode,state) { this.fire.doc(`games/${ roomcode }`).update({ state: state }); }

	playSound(soundSrc, game) {
		return new Promise((resolve, reject) => {
			var sound = new Audio();
			sound.preload = "auto";
			sound.autoplay = true;
			sound.loop = false;                       
			sound.onerror = reject;
			sound.onended = resolve;
			sound.src = '../../assets/audio/'+game+'/' + soundSrc;
		});
	}

}



// WEBPACK FOOTER //
// ./src/providers/helpers/helpers.ts